import { PaymentPlanTier } from '@/types/schema';

import { PAYMENT_PLAN_PRICING_MAP } from './constants';

function floatsAreWeirdInJS(cost: number) {
  return Math.round(cost * 10000) / 10000;
}

export function getCostForTraces(
  totalTraces: number | null,
  longlivedTraces: number | null,
  tier?: PaymentPlanTier | null,
  countedFreeTraces = 0,
  countedLonglivedFreeTraces = 0
) {
  let mTier;
  switch (tier) {
    case 'developer':
    case 'developer_legacy':
    case 'free':
      mTier = 'developer';
      break;
    case 'plus_legacy':
    case null:
    case undefined:
    case 'no_plan':
      mTier = 'plus';
      break;
    default:
      mTier = tier;
  }
  const {
    numFreeTraces,
    shortLivedPricePerTrace,
    longLivedPricePerTrace,
    pricePerTrace,
  } = PAYMENT_PLAN_PRICING_MAP[mTier];

  const totalPaid = Math.max(
    0,
    (totalTraces || 0) - Math.max(numFreeTraces - countedFreeTraces, 0)
  );
  const extendedPaid = Math.max(
    0,
    (longlivedTraces || 0) -
      Math.max(numFreeTraces - countedLonglivedFreeTraces, 0)
  );

  const totalExtended =
    totalPaid *
    floatsAreWeirdInJS(shortLivedPricePerTrace + longLivedPricePerTrace);

  const shortlivedLeftover =
    Math.max(0, totalPaid - extendedPaid) *
    floatsAreWeirdInJS(shortLivedPricePerTrace);

  const extended =
    extendedPaid *
    floatsAreWeirdInJS(shortLivedPricePerTrace + longLivedPricePerTrace);

  let maxCostEstimate: number | null = null;
  if (totalTraces !== null && longlivedTraces !== null) {
    maxCostEstimate = extended + shortlivedLeftover;
  } else if (totalTraces !== null && longlivedTraces === null) {
    maxCostEstimate = totalExtended;
  } else if (totalTraces === null) {
    maxCostEstimate = null;
  }

  return {
    maxCostEstimate,
    numFreeTraces,
    pricePerTrace,
  };
}
